import React, { useState } from 'react';
import back from '../../img/nazad.png';
import mapBtn from '../../img/mishen.png';

const DeviceDetalsHeader = ({ onClickPage, onClickBuck, onClickMup, imei_name, typeDevice, role }) => {
  // Определяем опции в зависимости от типа устройства

  // const arOptions = typeDevice === 'RS485' 
  //   ? ['Управление', 'Настройка'] 
  //   : ['Управление', 'Настройка', 'Барьеры', 'Пушки'];

    const arOptions = 
    (role === 1 && typeDevice === 'RS485') ? ['Управление', 'Настройка', 'DataModbus'] :
    (role === 2 && typeDevice === 'RS485') ? ['Управление', 'Настройка'] :
    typeDevice === 'RS485' ? ['Управление', 'Настройка'] :
    ['Управление', 'Настройка', 'Барьеры', 'Пушки'];
  
  const [value, setValue] = useState('0'); // Лучше явно указать начальное значение

  // Мемоизируем опции, чтобы не создавать заново при каждом рендере
  const options = React.useMemo(() => {
    return arOptions.map((text, index) => (
      <option key={index} value={index}>{text}</option>
    ));
  }, [arOptions]);

  const handlePageChange = (event) => {
    const selectedValue = event.target.value;
    setValue(selectedValue);
    onClickPage(selectedValue);
  };

  return (
    <div className="detalsHeader">
      <div className="detalsHeaderName">
        <h2>{imei_name}</h2>
      </div>
      <div className="headerNavigator">
        <div className="headerNavigatorBack">
          <button onClick={onClickBuck}>
            <img src={back} alt="Назад" />
          </button>
        </div>
        <div className="headerNavigatorSelect">
          <select value={value} onChange={handlePageChange}>
            {options}
          </select>
        </div>
        <div className="headerNavigatorMap">
          <button onClick={onClickMup}>
            <img src={mapBtn} alt="Карта" />
          </button>
        </div>
      </div>
    </div>
  );
};

// Опционально: оборачиваем в React.memo для предотвращения лишних перерендеров
export default React.memo(DeviceDetalsHeader);